<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Сертификаты карт

  .container.mt-5(v-if="loading")
    .white_block
      .row
        .col Загрузка...
  .container.mt-5(v-else)
    .white_block
      .row
        .col-sm-1 ID
        .col-sm-3 Имя
        .col-sm-3 Email
        .col-sm-3 Действителен до
        .col-sm-2 Действия
      .row.user(v-for="user in users")
        .col-sm-1 №{{ user.id }}
        .col-sm-3(style="overflow: hidden; text-overflow: ellipsis") {{ user.name }}
        .col-sm-3(style="overflow: hidden; text-overflow: ellipsis") {{ user.email }}
        .col-sm-3(:class="['certHighlight', user.certHighlight]") {{ user.cards_cert_expire }}
        .col-sm-2
          a.action(@click="refresh(user.id)", href="#", title="Обновить")
            i.fas.fa-sync
</template>
<script>
import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {
    [Tooltip.name]: Tooltip,
  },

  data() {
    return {
      users: [],
      loading: true,
    };
  },

  computed: {},

  mounted() {
    this.loadUsers();
  },

  methods: {
    async loadUsers() {
      this.loading = true;
      let users = (await apiDriver.admin.users.cardsCerts.get()).users;
      for (let u of users) {
        let cert_moment = moment(u.cards_cert_expire, "YYYY-MM-DD");
        u.cards_cert_expire = cert_moment.clone().format("DD.MM.YYYY");
        if (cert_moment < moment()) {
          u.certHighlight = "red";
        } else {
          if (cert_moment.clone().diff(moment(), "days") < 30) {
            u.certHighlight = "yellow";
          } else {
            u.certHighlight = "green";
          }
        }
      }
      this.users = users;
      this.loading = false;
    },
    async refresh(id) {
      this.$toast.info("Обновление сертификата...");
      let done = await apiDriver.admin.users.cardsCerts.refresh(id);
      console.log(done);
      if (done.done) {
        let u = this.users.find((u) => u.id == id);
        u.cards_cert_expire = moment()
          .add(1, "year")
          .add(1, "month")
          .subtract(1, "day")
          .format("DD.MM.YYYY");
        u.certHighlight = "green";
        this.$toast.success("Сертификат пользователя обновлен!");
      } else {
        this.$toast.error("Ошибка обновления сертификата!");
      }
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.user {
  &:hover {
    background: #eee;
  }
}

.action {
  padding: 1px 5px;
  border: 1px solid #eee;
  display: inline-block;
  margin-bottom: 1px;
  margin-top: 1px;
  border-radius: 3px;
  margin-right: 2px;
  color: #4e4e4e;

  &:hover {
    color: black;
    border-color: #d0d0d0;
  }
}

.certHighlight {
  font-weight: bold;

  &.red {
    color: #f44336;
  }

  &.yellow {
    color: #ff9800;
  }

  &.green {
    color: #009688;
  }
}

@media (prefers-color-scheme: dark) {
  .user {
    &:hover {
      background: #2e2e2e;
    }
  }

  .action {
    border: 1px solid #525252;
    color: #e3e3e3;

    &:hover {
      color: white;
      border-color: #d0d0d0;
    }
  }
}
</style>
</style>
